import React from 'react'

class UnderlineText extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11">
        <path
          fill="#343638"
          fillRule="evenodd"
          d="M8.5 9.36v1.23h-7V9.36h7zM2.761.59v4.608c0 .81.181 1.405.544 1.784.362.379.925.568 1.69.568.765 0 1.33-.19 1.694-.568.364-.379.546-.973.546-1.784V.59h1.001v4.842c0 .99-.277 1.736-.833 2.238-.555.502-1.358.754-2.408.754-1.05 0-1.851-.253-2.405-.76-.553-.506-.83-1.25-.83-2.232V.59h1.001z"
        />
      </svg>
    )
  }
}

export default UnderlineText
